import React from "react";
import { Switch, Route } from "react-router-dom";
import "./App.css";
import AlertMsg from "./Components/Alert/Alert";
import ColorChart from "./Components/ColorChart/ColorChart";
import Footer from "./Components/Footer/Footer";
import Navbar from "./Components/Navbar/Navbar";
import Sidebar from "./Components/Sidebar/Sidebar";
import Catagories from "./Pages/Catagories/Catagories";
import CheckoutPage from "./Pages/CheckoutPage/CheckoutPage";
import ConfirmOrderPage from "./Pages/ConfirmOrderPage/ConfirmOrderPage";
import ContactPage from "./Pages/ContactPage/ContactPage";
import HomePage from "./Pages/HomePage/HomePage";
import OrderConfirmed from "./Pages/OrderConfirmed/OrderConfirmed";
import ProductPage from "./Pages/ProductPage/ProductPage";
import ProductsPage from "./Pages/ProductsPage/ProductsPage";
const App = (props) => {
  return (
    <div className="App">
      <Navbar />
      <Sidebar />

      <Switch>
        <Route exact path="/" component={HomePage} />
        <Route exact path="/catagories" component={Catagories} />
        <Route exact path="/products/:catagory" component={ProductsPage} />
        <Route exact path="/product/:catagory/:id" component={ProductPage} />
        <Route exact path="/checkout" component={CheckoutPage} />
        <Route exact path="/confirm-order" component={ConfirmOrderPage} />
        <Route exact path="/thank-you" component={OrderConfirmed} />
        <Route exact path="/contact" component={ContactPage} />
      </Switch>
      <Footer />
      <AlertMsg />
      <ColorChart />
    </div>
  );
};

export default App;
